module.exports = __webpack_public_path__ + "img/entwurf_2.db4ead44.jpg";